import {Input} from 'antd'

import {Form, FormItem, Button} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {useDeclineRequest} from '..'

interface PushBackFormProps {
  requestUuid: string
  onClose: () => void
}

export default function PushBackForm({
  requestUuid,
  onClose,
}: PushBackFormProps) {
  const {mutate: declineRequest, isMutating: isDeclineRequestMutating} =
    useDeclineRequest(requestUuid, onClose)
  const inputRef = useInputFocus()

  const handleFinish = (values: any) => {
    declineRequest(values)
  }

  return (
    <Form onFinish={handleFinish}>
      <FormItem name="reason" label="Description" rules={FIELD_RULES}>
        <TextArea ref={inputRef} rows={7} />
      </FormItem>
      <Button block htmlType="submit" loading={isDeclineRequestMutating}>
        Save reason
      </Button>
    </Form>
  )
}

const {TextArea} = Input
